"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderTree_unstable", {
    enumerable: true,
    get: function() {
        return renderTree_unstable;
    }
});
const _jsxruntime = require("@fluentui/react-jsx-runtime/jsx-runtime");
const _reactutilities = require("@fluentui/react-utilities");
const _TreeProvider = require("../TreeProvider");
const renderTree_unstable = (state, contextValues)=>{
    (0, _reactutilities.assertSlots)(state);
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(_TreeProvider.TreeProvider, {
        value: contextValues.tree,
        children: state.open && /*#__PURE__*/ (0, _jsxruntime.jsx)(state.root, {
            children: state.root.children
        })
    });
};
